import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  canonicalUrl, 
  keywords = [], 
  image = '/rma_small_logo.png', 
  schema = null 
}) => {
  const siteTitle = 'Robomec Automation';
  const defaultDescription = 'Robomec Automation specializes in designing and manufacturing high-quality industrial machinery, including robotic welding systems, thermal cutting systems, and material handling solutions.';
  
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Industrial Machinery & Automation Solutions`;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords.length > 0 ? keywords.join(', ') : 'Robomec Automation, industrial machinery, robotic welding systems, thermal cutting systems, material handling, automation solutions';
  const metaImage = image.startsWith('http') ? image : `https://www.robomecautomation.com${image}`;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={metaImage} />
      
      {/* Optional JSON-LD schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonicalUrl: PropTypes.string,
  keywords: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
  schema: PropTypes.object
};

export default SEO; 